<!-- <div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center mt-3"
      style="color: #f3a43f; font-size: 48px; font-weight: 500"
    >
      Current Choirs
    </div> -->
    <!-- <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <div class="search-container">
        <input type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="getChoirList(searchText)" />
        <span class="search-icon">🔍</span>
      </div>
    </div> -->
  <!-- </div> -->

  <!-- <div class="row m-0 p-0 pb-5 mt-4 justify-content-center">
    <div class="card col-md-4 card_class" *ngFor="let item of ChoirList">
      <div class="card-image">
        <img
          src="{{
            item?.profilePic
              ? item?.profilePic
              : '../../../../../assets/images/dummy_Pic.svg'
          }}"
          style="height: 330px; width: 360px"
          alt="Choir"
        />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">{{
            convertSecondsToDate(item?.startDateInSeconds)
          }}</span> -->
          <!-- {{
            startDateInSeconds * 1000 | date : "medium" : "23 August 2024"
          }} -->
          <!-- <span class="price" *ngIf="item.amount != null && item.amount > 0"
            >${{ item?.amount }}</span
          >
        </div>

        <h2 class="card-title">{{ item?.title }}</h2>

        <p class="card-description" title="{{ item?.description }}">
          {{
            item?.description.length > 150
              ? (item.description | slice : 0 : 150) + "..."
              : item?.description
          }}
        </p>
        <div class="applyBtn p-4">
          <a
            href="#"
            class="apply-btn"
            [routerLink]="['/main/choir-detail']"
            [queryParams]="{ id: item?.choirId }"
            >Apply Now</a
          >
        </div>
      </div>
    </div> -->
    <!-- <div class="card col-md-4">
      <div class="card-image">
        <img src="../../../assets/images/dummyImage2.png" alt="Choir" />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">5 August 2024</span>
          <span class="price">$889.89</span>
        </div>
        <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>

        <p class="card-description">
          Lorem ipsum is simply dummy text of the printing and typesetting
          industry. Lorem ipsum....
        </p>
        <div class="applyBtn p-4">
          <a href="#" class="apply-btn">Apply Now</a>
        </div>
      </div>
    </div>
    <div class="card col-md-4">
      <div class="card-image">
        <img src="../../../assets/images/dummyImage3.png" alt="Choir" />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">5 August 2024</span>
          <span class="price">$889.89</span>
        </div>
        <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>

        <p class="card-description">
          Lorem ipsum is simply dummy text of the printing and typesetting
          industry. Lorem ipsum....
        </p>
        <div class="applyBtn p-4">
          <a href="#" class="apply-btn">Apply Now</a>
        </div>
      </div>
    </div>
    <div class="card col-md-4">
      <div class="card-image">
        <img src="../../../assets/images/dummyImage5.svg" alt="Choir" />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">5 August 2024</span>
          <span class="price">$889.89</span>
        </div>
        <h2 class="card-title">Beginner Choir <span>(4 weeks)</span></h2>

        <p class="card-description">
          Lorem ipsum is simply dummy text of the printing and typesetting
          industry. Lorem ipsum....
        </p>
        <div class="applyBtn p-4">
          <a href="#" class="apply-btn">Apply Now</a>
        </div>
      </div>
    </div> -->
  <!-- </div>
</div> -->


<div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center mt-3"
      style="color: #f3a43f; font-size: 48px; font-weight: 500"
    >
      Current Choirs
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="d-flex justify-content-center my-5">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Choir Cards -->
  <div
    class="row m-0 p-0 pb-5 mt-4 justify-content-center"
    *ngIf="!isLoading && ChoirList.length > 0"
  >
    <div
      class="card col-md-4 card_class"
      *ngFor="let item of ChoirList"
    >
      <div class="card-image">
        <img
          [src]="item?.profilePic || '../../../assets/images/dummy_Pic.svg'"
          style="height: 330px; width: 360px"
          alt="Choir"
        />
      </div>
      <div class="card-content">
        <div class="datDiv d-flex">
          <span class="date">{{ convertSecondsToDate(item?.startDateInSeconds) }}</span>
          <span class="price" *ngIf="item.amount != null && item.amount > 0">
            ${{ item?.amount }}
          </span>
        </div>

        <h2 class="card-title">{{ item?.title }}</h2>

        <p
          class="card-description"
          title="{{ item?.description }}"
        >
          {{
            item?.description.length > 150
              ? (item.description | slice : 0 : 150) + '...'
              : item?.description
          }}
        </p>

        <div class="applyBtn p-4">
          <a
            class="apply-btn"
            [routerLink]="['/main/choir-detail']"
            [queryParams]="{ id: item?.choirId }"
          >
            Apply Now
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- No Choirs Available -->
  <div *ngIf="!isLoading && ChoirList.length === 0" class="text-center text-muted my-5">
    No choirs found.
  </div>
</div>
